import styled from "styled-components";
import { getHexOpacity } from '../../../utils/pipes';

export const FlorenzSearchInput = styled.div`
  width: 100%;
  .zaia-input {
    width: 100%;
    position: relative;
    display: flex;
    .zaia-input-container {
      height: 36px;
      border-radius: 20px;
      padding: 0 10px;
      background-color: ${({forWhiteBackgroud}) => forWhiteBackgroud ? "#F0F0FF" : "#FFFFFF"};
      display: flex;
      align-items: center;
      min-width: 100px;
      width: 100%;
      box-sizing: border-box;
      margin-left: 10px;
      cursor: text;
      &:hover {
        border: 3px solid ${({forWhiteBackgroud, borderanimation}) => 
          borderanimation 
            ? forWhiteBackgroud 
              ? "#6C6BF5" 
              : "#FFFFFF" 
            : "none"};
        background-color:  ${({borderanimation}) => borderanimation && "#FFFFFF"};
        height: ${({borderanimation}) => borderanimation && "42px"};
        margin-left: ${({borderanimation}) => borderanimation && "7px"};
      }
      .icon-search {
        margin: 0 5px 0px 0;
        color: #0C0AA2;
      }
      .icon-search-delete {
        color: #0C0AA2;
        cursor: pointer;
        .icon {
          font-size: 9px;
        }
      }
      input {
        border: none;
        background-color: transparent;
        width: 100%;
        font-family: Nunito Sans;
        font-size: 17px;
        color: #1F1F52;
        &:focus {
          outline: none;
        }
        &::placeholder { 
          color: #0C0AA2;
          font-size: 17px;
          margin-left: 30px;
          font-family: "Nunito Sans";
        }
      }
    }
    .zaia-input-container:hover input::placeholder {
      font-family: Nunito Sans Bold;
    }
  }
`